import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import Drum from "./Drum";
function App() {
    return <div>
        
        <Header />
        <Drum />
        <Footer />
    </div>
}

export default App;